import { TwoLayoutCardProps } from '../constants/interface/interface';

const TwoLayoutCard = ({ icon, heading, content }: TwoLayoutCardProps) => {
  return (
    <>
      <div className="twolayout-card" data-aos="fade-up">
        <div className="twolayout-card-icon">{icon}</div>
        <div className="twolayout-card-cnt">
          <h4>{heading}</h4>
          <p>{content}</p>
        </div>
      </div>
    </>
  );
};

export default TwoLayoutCard;
